export const en = {
  // Navigation
  nav: {
    home: "Home",
    ourServices: "Our Services",
    aboutUs: "About Us",
    ourTeam: "Our Team",
    contactUs: "Contact Us"
  },

  // Hero Section
  hero: {
    title: "Expand globally with confidence",
    subtitle: "We support you in setting up your business in the UAE, Saudi Arabia, and Russia.",
    consultationTitle: "Book a Free Consultation Now",
    startNow: "Start Now",
    modalTitle: "Book a Free Consultation",
    countrySelect: "Select Your Country",
    countryPlaceholder: "Choose a country",
    personalInfo: "Personal Information",
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    nationality: "Nationality",
    phoneNumber: "Phone Number",
    servicesLabel: "The Services you want",
    serviceSelect: "Select a service",
    service1: "Open Bank Accounts",
    service2: "Visa & Immigration Services",
    service3: "Hotel Booking",
    service4: "Flight Tickets",
    service5: "Website Development",
    service6: "Mobile App Development",
    submit: "Submit"
  },

  // About Us Section
  aboutUs: {
    title: "About Us",
    paragraph1: "Itqan Business Services was founded in the United Arab Emirates to help entrepreneurs and businesses establish their companies easily and quickly. We provide a full range of services including mainland and free zone company formation, PRO & government services, tax and VAT consultancy, financial statements, and document attestation.",
    paragraph2: "Over the years, we have become a trusted partner for entrepreneurs and SMEs, delivering seamless legal, financial, and regulatory solutions that support growth in the UAE and beyond. Our mission is clear: to make business setup and operations simple, fast, and reliable — so you can focus on achieving success."
  },

  // Services Section
  services: {
    title: "Our Services",
    subtitle: "We provide comprehensive business solutions",
    startingFrom: "Start from",
    mainlandCompany: {
      name: "Mainland Company Formation",
      desc: "Set up your mainland company with ease We handle all the legal steps so you can focus on growing your business.",
      price: "10,000 AED"
    },
    freeZoneCompany: {
      name: "Free Zone Company Formation",
      desc: "Launch your free zone business quickly and cost-effectively enjoy flexible ownership and simplified setup.",
      price: "6,000 AED"
    },
    proServices: {
      name: "PRO & Government Services",
      desc: "From license renewals to golden visas we manage all your government transactions smoothly."
    },
    taxConsultancy: {
      name: "Tax & VAT Consultancy",
      desc: "Stay compliant with expert tax and VAT guidance we help you minimize risks and maximize efficiency."
    },
    financialStatements: {
      name: "Financial Statements",
      desc: "Accurate financial reports that keep your business on track we ensure transparency and compliance."
    },
    documentAttestation: {
      name: "Document Attestation",
      desc: "Fast and reliable document attestation services for all your business needs."
    },
    bankAccounts: {
      name: "Open Bank Accounts",
      desc: "Professional assistance in opening bank accounts for individuals and businesses in the UAE and internationally."
    },
    visaServices: {
      name: "Visa & Immigration Services",
      desc: "Comprehensive visa and immigration services including tourist visas, business visas, and residency permits."
    },
    hotelBooking: {
      name: "Hotel Booking",
      desc: "Convenient hotel booking services for business trips and leisure travel with competitive rates."
    },
    flightTickets: {
      name: "Flight Tickets",
      desc: "Reliable flight booking services with access to the best deals and routes worldwide."
    },
    websiteDevelopment: {
      name: "Website Development",
      desc: "Custom website development services to establish your online presence and grow your business.",
      price: "1,500 AED"
    },
    mobileAppDevelopment: {
      name: "Mobile App Development",
      desc: "Professional mobile application development for iOS and Android platforms.",
      price: "3,500 AED"
    }
  },

  // Our Team Section
  ourTeam: {
    title: "Our Team",
    subtitle: "Meet our expert professionals",
    members: [
      {
        name: "Eng/Hana",
        role: "Business setup team Leader"
      },
      {
        name: "Eng/Ali",
        role: "Business setup team Leader"
      },
      {
        name: "Eng/Abdalla",
        role: "Business setup team Leader"
      },
      {
        name: "Eng/Sara",
        role: "Business setup team Leader"
      }
    ]
  },

  // Reviews Section
  reviews: {
    title: "What Our Clients Say",
    subtitle: "Testimonials from satisfied customers",
    testimonials: [
      {
        name: "John Doe",
        role: "CEO, TechStart Inc.",
        text: "Itqan made setting up my company in Dubai so simple and fast. Their team handled everything professionally, and I could start my business without stress. The free zone setup was completed in just 3 days!"
      },
      {
        name: "Sam Woods",
        role: "Marketing Manager, Global Solutions",
        text: "Thanks to their tax consultancy, I now have full confidence that my business is compliant and financially secure. Their expertise saved me thousands in potential penalties."
      },
      {
        name: "Michael Brown",
        role: "Business Owner, Retail Chain",
        text: "The PRO services team at Itqan is exceptional. They handled all my government transactions smoothly, from license renewals to visa applications. Highly recommended!"
      },
      {
        name: "Mike Roberson",
        role: "Freelancer, Digital Agency",
        text: "As a freelancer, I needed help with document attestation and bank account opening. Itqan made everything so easy and affordable. Now I can focus on my clients while they handle the paperwork."
      },
      {
        name: "David Lee",
        role: "Entrepreneur, E-commerce",
        text: "Their financial statement services are top-notch. The reports are accurate, detailed, and helped me secure funding for my business expansion. Professional service throughout!"
      }
    ]
  },

  // Partners Section
  partners: {
    title: "Our Partners",
    subtitle: "Trusted by leading organizations"
  },

  // Contact Us Section
  contactUs: {
    title: "Contact Us",
    subtitle: "Get in touch with us",
    getInTouch: "Get In Touch",
    contactInfo: "Contact Information",
    sendMessage: "Send Message",
    name: "Name",
    email: "Email",
    subject: "Subject",
    message: "Message",
    fullName: "Full Name",
    fullNamePlaceholder: "Enter your name",
    emailAddress: "Email Address",
    emailPlaceholder: "Enter your email",
    phoneNumber: "Phone Number",
    phonePlaceholder: "Phone Number",
    activity: "Activity",
    activityPlaceholder: "Enter your activity",
    submit: "Submit"
  },

  // Footer
  footer: {
    allRightsReserved: "All Rights Reserved",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    description: "Itqan Business Services – Making business setup easy and fast.",
    location: "Location: Dubai, United Arab Emirates",
    phone: "📞 Phone: +971 XXX XXX XXX",
    email: "✉️ Email: info@itqan.com",
    copyright: "© 2025 Itqan Business Services. All Rights Reserved.",
    companyProfile: "Company Profile"
  },

  // Ad Section
  ad: {
    title: "Expand globally with confidence",
    startNow: "Start Now"
  },

  // Statistics Section
  statistics: {
    title: "Our Achievements",
    subtitle: "Numbers that speak for our success",
    clients: "Happy Clients",
    experience: "Years Experience",
    partners: "Trusted Partners"
  }
}; 